import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/Layout/index'
import Home from '@/views/Home'
import MobileHome from '@/views/Mobile/MobileHome'
import Abouts from '@/views/Abouts'
import Solutions from '@/views/Solutions'
import News from '@/views/News'
import ServiceSupport from '@/views/ServiceSupport'
import RecruitTalents from '@/views/RecruitTalents'
import Addnews from '@/views/Addnews'
import Product from '@/views/Product'
import Contact from '@/views/Contact'
import NewsDetail from '@/views/NewsDetail'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      // 如果不是通过上述行为切换组件，就会让页面回到顶部
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/Home',
      children: [
        {
          path: '/Home',
          name: 'Home',
          component: Home
        }, {
          path: '/MobileHome',
          name: 'MobileHome',
          component: MobileHome
        },
        {
          path: '/Abouts',
          name: 'Abouts',
          component: Abouts
        },
        {
          path: '/Solutions',
          name: 'Solutions',
          component: Solutions
        },
        {
          path: '/News',
          name: 'News',
          component: News
        },
        {
          path: '/ServiceSupport',
          name: 'ServiceSupport',
          component: ServiceSupport
        },
        {
          path: '/RecruitTalents',
          name: 'RecruitTalents',
          component: RecruitTalents
        }, {
          path: '/Addnews',
          name: 'Addnews',
          component: Addnews
        },
        {
          path: '/Product',
          name: 'Product',
          component: Product
        },
        {
          path: '/Contact',
          name: 'Contact',
          component: Contact
        },
        {
          path: '/NewsDetail',
          name: 'NewsDetail',
          component: NewsDetail
        }
      ]
    },
    {
      path: '*',
      redirect: '/Home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js